'use strict';
import {stateGo} from 'redux-ui-router';
import {getOrganization} from '../../app/model/reducers/state';
import {SCOPE_DESTROY} from '../../config/constants/view-events';
import {getCollection, getId, getLink} from '../../core-utilities/domain/ReduxUtils';
import {epicErrorHandler, eventToObservable} from '../../core-utilities/rx-utils';
import {PERSONNEL_COLLECTION} from '../domain/PersonDomain';
import {TEAMS_COLLECTION} from '../domain/TeamDomain';
import {reduxList as peopleList} from '../redux/peopleList';
import inviteCreateTemplate from './admin/invite-create.html';
import {logger} from './logger';
import personnelCreateTemplate from './personnel-create.html';
import teamsEditDialogTemplate from './teams-edit-dialog.html';


PersonnelHomeController.$inject = [
  '$scope',
  '$ngRedux',
  '$ionicViewSwitcher',
  '$contextMenu',
  '$modal',
  '$popup',
  '$translate',
  'OrganizationDomain',
  'PersonDomain',
];

export function PersonnelHomeController(
  $scope,
  $ngRedux,
  $ionicViewSwitcher,
  $contextMenu,
  $modal,
  $popup,
  $translate,
  OrganizationDomain,
  PersonDomain,
) {
  /*****************************************************************************************************************
   * Initialize
   ****************************************************************************************************************/
  const leave$ = eventToObservable($scope, SCOPE_DESTROY);
  const vm = $scope.personnelHome = this;
  const MAX_TEAMS_IN_CONTEXT_MENU = 3;

  // TODO: replace with rest api list
  $scope.$evalAsync(init);

  function init() {
    $ngRedux.state$
      .map(getOrganization)
      .distinctUntilChanged(null, organization => getId(organization))
      .catch(epicErrorHandler(logger, 'organization$'))
      .takeUntil(leave$)
      .subscribe(organization => $scope.$evalAsync(() =>
        vm.teamTypes = OrganizationDomain.$getTeamTypesList(getId(organization))
      ));
  }

  bindReactProps();

  function bindReactProps() {
    vm.viewProps = {
      onClickOptions: showMenu,
      onClickOptions_wrap: false,
      onClickItem: (e, model) => goToDetails(model),
      onClickItem_wrap: false,
      onItemContextMenu: (e, model) => openItemContextMenu(model),
      onItemContextMenu_wrap: false,
    };
  }

  /*****************************************************************************************************************
   * Header Buttons
   ****************************************************************************************************************/


  /*****************************************************************************************************************
   * Context Menu Actions
   ****************************************************************************************************************/

  function generate_CREATE_TEAM(teamType) {
    return {
      permission: 'organization_teams_edit',
      action: {
        messageId: 'personnel.home.context.team.add.label',
        messageParams: {teamType: teamType.name},
        action: openAddTeamDialog.bind(vm, teamType),
      },
    };
  }

  function generate_DELETE_TEAM(model) {
    return {
      permission: 'organization_teams_edit',
      action: {
        messageId: 'personnel.home.context.teams.delete.label',
        messageParams: {teamType: model.name},
        action: deleteTeam.bind(vm, model), important: true,
      },
    };
  }

  function generate_DELETE_CONTACT(person) {
    return {
      permission: 'organization_personnel_edit',
      action: {
        messageId: 'personnel.home.context.person.delete.label',
        action: deletePerson.bind(vm, person),
        important: true,
      },
    };
  }

  function generate_SEND_INVITE(person) {
    return {
      permission: 'organization_access_edit',
      action: {
        messageId: 'personnel.home.context.person.invite.label',
        action: sendInvite.bind(vm, person),
      },
    };
  }

  const CREATE_CONTACT = {
    permission: 'organization_personnel_edit',
    action: {messageId: 'personnel.home.context.person.add.label', action: addPerson},
  };

  const TEAMS_SELECT_ACTION = {
    permission: 'organization_teams_edit',
    action: {messageId: 'personnel.home.context.team.list.add.label', action: addTeamFromTypeSelection},
  };

  const MANAGE_TEAM_TYPES = {
    permission: 'organization_team-types_edit',
    action: {messageId: 'personnel.home.context.teams.manage.types.label', action: manageTeamTypes},
  };

  const MANAGE_ORG_MEMBERS = {
    permission: 'organization_access_edit',
    action: {messageId: 'personnel.home.context.members.manage.label', action: manageInvites},
  };

  function goToDetails(model) {
    switch (getCollection(model)) {
      case PERSONNEL_COLLECTION:
        return goToPersonDetails(model);

      case TEAMS_COLLECTION:
        return goToTeamDetails(model);

      default:
        return Promise.resolve(null);
    }
  }

  function openItemContextMenu(model) {
    switch (getCollection(model)) {
      case PERSONNEL_COLLECTION:
        return showPersonMenu(model);

      case TEAMS_COLLECTION:
        return showTeamMenu(model);

      default:
        return Promise.resolve(null);
    }
  }

  function showMenu() {
    const orgId = getId(getOrganization($ngRedux.getState()));
    if (!orgId) return;

    const checkActions = [];
    $contextMenu.addActionByOrg(checkActions, orgId, CREATE_CONTACT);

    let typesKeys;
    if (vm.teamTypes) {
      typesKeys = Object.keys(vm.teamTypes);
      const typesLength = typesKeys.length;

      for (let i = 0, minTypes = Math.min(MAX_TEAMS_IN_CONTEXT_MENU, typesLength); i < minTypes; i++) {
        $contextMenu.addActionByOrg(checkActions, orgId, generate_CREATE_TEAM(vm.teamTypes[typesKeys[i]]));
      }

      if (typesLength > MAX_TEAMS_IN_CONTEXT_MENU) {
        $contextMenu.addActionByOrg(checkActions, orgId, TEAMS_SELECT_ACTION);
      }
    }

    $contextMenu.addActionByOrg(checkActions, orgId, MANAGE_TEAM_TYPES);
    $contextMenu.addActionByOrg(checkActions, orgId, MANAGE_ORG_MEMBERS);

    return $contextMenu.showByPermission({
      titleMessageId: 'personnel.home.context.title.label',
      cancelMessageId: 'defaults.context.cancel.label',
      actions: checkActions,
    });
  }

  function showTeamMenu(team) {
    if (!team) return;
    const orgId = getId(getOrganization($ngRedux.getState()));
    if (!orgId) return;

    const checkActions = [];
    $contextMenu.addActionByOrg(checkActions, orgId, generate_DELETE_TEAM(team));

    return $contextMenu.showByPermission({
      titleMessageId: 'default.options.context.title.label',
      titleMessageParams: {name: team.name},
      cancelMessageId: 'defaults.context.cancel.label',
      actions: checkActions,
    });
  }

  function showPersonMenu(person) {
    if (!person) return;
    const orgId = getId(getOrganization($ngRedux.getState()));
    if (!orgId) return;

    const checkActions = [];

    if (!person.aliasFor) {
      $contextMenu.addActionByOrg(checkActions, orgId, generate_SEND_INVITE(person));
      $contextMenu.addActionByOrg(checkActions, orgId, generate_DELETE_CONTACT(person));
    }

    return $contextMenu.showByPermission({
      titleMessageId: 'default.options.context.title.label',
      titleMessageParams: {name: person.name},
      cancelMessageId: 'defaults.context.cancel.label',
      actions: checkActions,
    });
  }

  function manageInvites() {
    $ionicViewSwitcher.nextDirection('forward');
    $ngRedux.dispatch(stateGo('app.members-manage'));
  }

  function addPerson() {
    $modal.show({
      template: personnelCreateTemplate,
      controller: 'PersonnelCreateController',
      animation: 'slide-in-up',
      locals: {
        profile: null,
        organization: getOrganization($ngRedux.getState()),
      },
    });
  }

  function addTeamFromTypeSelection() {
    openSelectTeamTypeDialog()
      .then(function (teamType) {
        openAddTeamDialog(teamType);
      }, _onError);
  }

  function openSelectTeamTypeDialog() {
    return $modal.showBasicSelector({
      locals: {
        header: 'team.types.select.header.label',
        loadList: () => OrganizationDomain.$getTeamTypesList(getId(getOrganization($ngRedux.getState()))),
      },
    });
  }

  function openAddTeamDialog(teamType) {
    $modal.show({
      template: teamsEditDialogTemplate,
      controller: 'TeamsEditDialogController',
      locals: {
        team: null,
        teamType: teamType,
      },
    });
  }

  function manageTeamTypes() {
    $ionicViewSwitcher.nextDirection('forward');
    $ngRedux.dispatch(stateGo('app.team-types-manage'));
  }

  function sendInvite(model) {
    if (model) {
      legacyPersonConverter(model).then(person =>
        $modal.show({
          template: inviteCreateTemplate,
          controller: 'InvitesCreateController',
          locals: {
            person: person,
            invite: null,
            organization: getOrganization($ngRedux.getState()),
          },
        })
      );
    }
  }

  function legacyPersonConverter(model) {
    if (model.aliasFor) {
      return PersonDomain.$get(getId(model))
        .then(person => person.$loaded().then(() => person));
    } else {
      return PersonDomain.$get(getId(model));
    }
  }

  function deleteTeam(team) {
    if (team) {
      return Promise
        .props({
          title: $translate('personnel.home.context.teams.delete.label', {teamType: team.type.name}),
          message: $translate('default.delete.confirmation.message', {target: team.name}),
        })
        .then(translations => confirmDeleteItem(team, translations))
        .catch(_onError);
    }
  }

  function deletePerson(person) {
    if (person) {
      return Promise
        .props({
          title: $translate('personnel.home.context.person.delete.label'),
          message: $translate('default.delete.confirmation.message', {target: person.name}),
        })
        .then(translations => confirmDeleteItem(person, translations))
        .catch(_onError);
    }
  }

  function confirmDeleteItem(item, translations) {
    return $popup
      .confirm({
        title: translations.title,
        template: '<div style="text-align: center;">' + translations.message + '</div>',
      })
      .then(result => result && $ngRedux.dispatch(peopleList.actions.deleteItem({
        id: getId(item),
        collection: getCollection(item),
      }, {
        parentId: getLink(item, 'organization').id,
      })));
  }

  function _onError(err) {
    logger.error({err}, 'Error occurred in PersonnelHomeController');
  }


  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/

  function goToTeamDetails(team) {
    $ionicViewSwitcher.nextDirection('forward');
    $ngRedux.dispatch(stateGo('app.teams-detail', {teamId: getId(team)}));
  }

  function goToPersonDetails(person) {
    $ionicViewSwitcher.nextDirection('forward');
    $ngRedux.dispatch(stateGo('app.personnel-detail', {personId: getId(person)}));
  }

  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/
}



// WEBPACK FOOTER //
// ./src/js/personnel/controllers/PersonnelHomeController.js